// ポータル画面から起動の機能を閉じる処理
export const funcClose = () => {
	const openType = localStorage.getItem('openType');
	const portalReturnUrlData = localStorage.getItem('portalReturnUrlData');

	if (localStorage.getItem('portalFlg') === '0') {
		// 遷移種別が「1：自画面を遷移する」の場合
		if (openType && openType === '1') {
			if (portalReturnUrlData) {
				const portalUrlData = JSON.parse(portalReturnUrlData);
				// 自画面が指定した遷移元URLに遷移する
				window.location.href = portalUrlData.migrateUrl;
			}
			// 遷移種別が「0：自画面を閉じる」の場合
		} else {
			// window.close()で現在のウィンドウを閉じて、且つ親画面にendViewのメッセージ通知する
			window.close();
			if (window.opener && window.opener.closed === false) {
				// 呼び出し元ウィンドウが生きている場合はそちらで処理してもらう
				window.opener.postMessage('endView', '*');
			}
		}
	}
};



// WEBPACK FOOTER //
// ./src/utils/StartupUtils.ts